import api from '@/api/student-score-delete-by-session'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  student_id: null,
  ac_status_id: null,
  class_id: null,
  students: [],
  academic_statuses: [],
  classes: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_STUDENT_ID(state, value) {
    state.student_id = value
  },
  SET_AC_STATUS_ID(state, value) {
    state.ac_status_id = value
  },
  SET_CLASS_ID(state, value) {
    state.class_id = value
  },
  SET_STUDENTS(state, value) {
    state.students = value
  },
  SET_ACADEMIC_STATUSES(state, value) {
    state.academic_statuses = value
  },
  SET_CLASSES(state, value) {
    state.classes = value
  },
  RESET_FILTER(state) {
    state.student_id = null
    state.ac_status_id = null
    state.class_id = null
    state.classes = []
  },
  RESET_STATE(state) {
    state.resources = []
    state.search = null
    state.edit_data = []
    state.student_id = null
    state.ac_status_id = null
    state.class_id = null
    state.students = []
    state.academic_statuses = []
    state.classes = []
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return api.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  fetchDeleteRecords(context, attributes = {}) {
    const params = Object.assign(
      {
        student_id: context.state.student_id,
        class_id: context.state.class_id
      },
      attributes
    )

    return api.getDeleteRecords({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  getStudents(context, attributes = {}) {
    return api.getStudents({ params: attributes }).then(response => {
      context.commit('SET_STUDENTS', response.data)
      return Promise.resolve(response)
    })
  },
  getAcademicStatuses(context) {
    return api.getAcademicStatuses().then(response => {
      context.commit('SET_ACADEMIC_STATUSES', response.data)
      return Promise.resolve(response)
    })
  },
  getStudentClasses(context, attributes = {}) {
    return api.getStudentClasses({ params: attributes }).then(response => {
      context.commit('SET_CLASSES', response.data)
      return Promise.resolve(response)
    })
  },
  destroy(context, data) {
    return api.destroy(data)
  }
}
